
const types = new Map();

function defineType(item) {
    types.set(item.id, item)
}

const FatalErrorOffset = 0;             //Offset for fatal errors.
const WarningErrorOffset = 50;          //Offset for warnings errors.
const O2CalibrationErrorOffset = 100;   //Offset for recalibration errors.
const DiagnosticErrorOffset = 120;      //Offset for diagnostic errors. These are not reported to the user but are recorded.

const fatal = 'fatal';
const warning = 'warning';
const calibration = 'calibration';
const diagnostic = 'diagnostic';

const itemTypes = {

    fatalCategory: fatal,
    warningCategory: warning,
    calibrationCategory: calibration,
    diagnosticCategory: diagnostic,

    category(errorCode) {

        if (errorCode < 50)
            return fatal;
        if (errorCode < 100)
            return warning;
        if (errorCode < 120)
            return calibration;

        return diagnostic;
    },

    find(errorCode) {
        let found = types.get(errorCode) ?? {
            id: errorCode,
            detail: '',
        };
        found.catgory = this.category(errorCode);
        return found;
    }
};

let idx = 0;

defineType({
    id: FatalErrorOffset + 0, order: idx++, detail: 'No Error.'  //VM_FATAL_ERROR_NONE
});

defineType({
    id: FatalErrorOffset + 1, order: idx++, detail: 'Initialization error, shutting off.'  //VM_FATAL_ERROR_INIT
});

defineType({
    id: FatalErrorOffset + 2, order: idx++, detail: 'Too hot, shutting off.'  //VM_FATAL_ERROR_TOO_HOT
});

defineType({
    id: FatalErrorOffset + 3, order: idx++, detail: 'Too cold, shutting off.'  //VM_FATAL_ERROR_TOO_COLD
});

defineType({
    id: FatalErrorOffset + 4, order: idx++, detail: 'Sat idle too long, shutting off.'  //VM_FATAL_ERROR_IDLE_TIMEOUT
});

defineType({
    id: FatalErrorOffset + 5, order: idx++, detail: ''  //VM_FATAL_ERROR_DEAD_BATTERY_LBO_V
});

defineType({
    id: FatalErrorOffset + 6, order: idx++, detail: ''  //VM_FATAL_ERROR_DEAD_BATTERY_SOC
});

defineType({
    id: FatalErrorOffset + 7, order: idx++, detail: 'Battery is out of charge, shutting off.'  //VM_FATAL_ERROR_DEAD_BATTERY_STARTUP
});

defineType({
    id: FatalErrorOffset + 8, order: idx++, detail: 'Failed to initialize environmental sensor.\n Send unit in for service.'  //VM_FATAL_ERROR_BME_NO_INIT
});

defineType({
    id: FatalErrorOffset + 9, order: idx++, detail: 'Failed to initialize oxygen sensor.\n Send unit in for service.'  //VM_FATAL_ERROR_ADS_NO_INIT
});


defineType({
    id: FatalErrorOffset + 10, order: idx++, detail: 'Failed to initialize flow sensor.\n Send unit in for service.'  //VM_FATAL_ERROR_AMS_DISCONNECTED
});

defineType({
    id: FatalErrorOffset + 11, order: idx++, detail: 'Failed to initialize sensor communication.\n Send unit in for service.'  //VM_FATAL_ERROR_TWI_NO_INIT
});

defineType({
    id: FatalErrorOffset + 12, order: idx++, detail: 'Failed to write a page to flash memory.\n Send unit in for service.'  //VM_FATAL_ERROR_FAILED_FLASH_WRITE
});

defineType({
    id: FatalErrorOffset + 13, order: idx++, detail: 'Failed to erase a page from flash memory.\n Send unit in for service.'  //VM_FATAL_ERROR_FAILED_FLASH_ERASE
});


//VM_ERROR_WARN
defineType({
    id: WarningErrorOffset + 6, order: idx++, detail: 'No warning.'  //VM_WARN_ERROR_NONE
});

defineType({
    id: WarningErrorOffset + 1, order: idx++, detail: 'Mask leak detected.'  //VM_WARN_ERROR_MASK_LEAK
});

defineType({
    id: WarningErrorOffset + 2, order: idx++, detail: 'User piece too small.'  //VM_WARN_ERROR_VENTURI_TOO_SMALL
});

defineType({
    id: WarningErrorOffset + 3, order: idx++, detail: 'User piece too big.'  //VM_WARN_ERROR_VENTURI_TOO_BIG
});

defineType({
    id: WarningErrorOffset + 4, order: idx++, detail: 'Device very hot.'  //VM_WARN_ERROR_TOO_HOT
});

defineType({
    id: WarningErrorOffset + 5, order: idx++, detail: 'Device very cold.'  //VM_WARN_ERROR_TOO_COLD
});

defineType({
    id: WarningErrorOffset + 6, order: idx++, detail: 'Breathing less than valve trigger.'  //VM_WARN_ERROR_UNDER_BREATHING_VALVE
});

defineType({
    id: WarningErrorOffset + 7, order: idx++, detail: 'Oxygen sensor too humid.'  //VM_WARN_ERROR_O2_TOO_HUMID
});

defineType({
    id: WarningErrorOffset + 8, order: idx++, detail: 'Oxygen sensor dried.'  //VM_WARN_ERROR_O2_TOO_HUMID_END
});

defineType({
    id: WarningErrorOffset + 9, order: idx++, detail: 'Breathing during ambient calibration.\n Hold your breath for 5 seconds.'  //VM_WARN_ERROR_BREATHING_DURING_DIFFP_CALIB
});

defineType({
    id: WarningErrorOffset + 10, order: idx++, detail: 'Many breaths rejected.'  //VM_WARN_ERROR_TOO_MANY_CONSECUTIVE_BREATHS_REJECTED
});


defineType({
    id: WarningErrorOffset + 11, order: idx++, detail: 'Low battery.'  //VM_WARN_ERROR_LOW_BATTERY_VOLTAGE
});

defineType({
    id: WarningErrorOffset + 12, order: idx++, detail: 'Thermal change occurring.'  //VM_WARN_ERROR_THERMAL_SHOCK_BEGIN
});

defineType({
    id: WarningErrorOffset + 13, order: idx++, detail: 'Thermal change slowed.'  //VM_WARN_ERROR_THERMAL_SHOCK_END
});

defineType({
    id: WarningErrorOffset + 14, order: idx++, detail: 'Ventilation out of range.'  //VM_WARN_ERROR_FINAL_VE_OUT_OF_RANGE
});



defineType({
    id: O2CalibrationErrorOffset + 0, order: idx++, detail: 'No calibration message.'  //VM_O2_RECALIB_NONE
});

defineType({
    id: O2CalibrationErrorOffset + 1, order: idx++, detail: 'O2 sensor signal drifted.'  //VM_O2_RECALIB_DRIFT
});

defineType({
    id: O2CalibrationErrorOffset + 2, order: idx++, detail: 'Ambient pressure changed a lot.'  //VM_O2_RECALIB_PRESSURE_DRIFT
});

defineType({
    id: O2CalibrationErrorOffset + 3, order: idx++, detail: 'Temperature changed a lot.'  //VM_O2_RECALIB_TEMPERATURE_DRIFT
});

defineType({
    id: O2CalibrationErrorOffset + 4, order: idx++, detail: 'Maximum time between calibrations reached.'  //VM_O2_RECALIB_TIME_MAX
});

defineType({
    id: O2CalibrationErrorOffset + 5, order: idx++, detail: '5 minute recalibration.'  //VM_O2_RECALIB_TIME_5MIN
});

defineType({
    id: O2CalibrationErrorOffset + 6, order: idx++, detail: 'Post-thermal shock calibration.'  //VM_O2_RECALIB_REASON_THERMAL_SHOCK_OVER
});


//VM_ERROR_DIAG

defineType({
    id: DiagnosticErrorOffset + 0, order: idx++, detail: 'Calibration: waiting for user to start breathing.'  //VM_DIAG_ERROR_FLOW_DELAY_RESET
});

defineType({
    id: DiagnosticErrorOffset + 1, order: idx++, detail: 'Breath rejected; too jittery.'  //VM_DIAG_ERROR_BREATH_TOO_JITTERY
});

defineType({
    id: DiagnosticErrorOffset + 2, order: idx++, detail: 'Breath rejected; segment too short.'  //VM_DIAG_ERROR_SEGMENT_TOO_SHORT
});

defineType({
    id: DiagnosticErrorOffset + 3, order: idx++, detail: 'Breath rejected; breath too short.'  //VM_DIAG_ERROR_BREATH_TOO_SHORT
});

defineType({
    id: DiagnosticErrorOffset + 4, order: idx++, detail: 'Breath rejected; breath too small.'  //VM_DIAG_ERROR_BREATH_TOO_SHALLOW
});


defineType({
    id: DiagnosticErrorOffset + 5, order: idx++, detail: 'Breath rejected; Rf out of range.'  //VM_DIAG_ERROR_FINAL_RF_OUT_OF_RANGE
});

defineType({
    id: DiagnosticErrorOffset + 6, order: idx++, detail: 'Breath rejected; Tv out of range.'  //VM_DIAG_ERROR_FINAL_TV_OUT_OF_RANGE
});

defineType({
    id: DiagnosticErrorOffset + 7, order: idx++, detail: 'Breath rejected; Ve out of range.'  //VM_DIAG_ERROR_FINAL_VE_OUT_OF_RANGE
});

defineType({
    id: DiagnosticErrorOffset + 8, order: idx++, detail: 'Breath rejected; FeO2 out of range.'  //VM_DIAG_ERROR_FINAL_FEO2_OUT_OF_RANGE
});

defineType({
    id: DiagnosticErrorOffset + 9, order: idx++, detail: 'Breath rejected; VO2 out of range.'  //VM_DIAG_ERROR_FINAL_VO2_OUT_OF_RANGE
});

defineType({
    id: DiagnosticErrorOffset + 10, order: idx++, detail: 'Device initialized.'  //VM_DIAG_ERROR_DEVICE_INITIALIZED
});

defineType({
    id: DiagnosticErrorOffset + 11, order: idx++, detail: 'Device attempted to enter Record mode\n before completing calibration.'  //VM_DIAG_ERROR_TRIED_RECORD_BEFORE_CALIB
});

defineType({
    id: DiagnosticErrorOffset + 12, order: idx++, detail: 'Oxygen sensor calibration waveform is volatile.'  //VM_DIAG_ERROR_O2_CALIB_AVG_TOO_VOLATILE
});

defineType({
    id: DiagnosticErrorOffset + 13, order: idx++, detail: 'Oxygen sensor reading clipped at its maximum value.'  //VM_DIAG_ERROR_ADS_HIT_MAX_VALUE
});

defineType({
    id: DiagnosticErrorOffset + 17, order: idx++, detail: 'Valve opened.'  //VM_DIAG_ERROR_VALVE_REQUEST_OPEN
});

defineType({
    id: DiagnosticErrorOffset + 18, order: idx++, detail: 'Valve closed.'  //VM_DIAG_ERROR_VALVE_REQUEST_CLOSE
});

defineType({
    id: DiagnosticErrorOffset + 19, order: idx++, detail: 'Calib diff: minimum.'  //VM_DIAG_ERROR_CALIB_ADC_THEO_DIFF_MINIMUM
});

defineType({
    id: DiagnosticErrorOffset + 20, order: idx++, detail: 'Calib diff: small.'  //VM_DIAG_ERROR_CALIB_ADC_THEO_DIFF_SMALL
});

defineType({
    id: DiagnosticErrorOffset + 21, order: idx++, detail: 'Calib diff: medium.'  //VM_DIAG_ERROR_CALIB_ADC_THEO_DIFF_MEDIUM
});

defineType({
    id: DiagnosticErrorOffset + 22, order: idx++, detail: 'Calib diff: large.'  //VM_DIAG_ERROR_CALIB_ADC_THEO_DIFF_LARGE
});

//Don't disclose what are these error codes.
//case (DiagnosticErrorOffset + 14):       //VM_DIAG_ERROR_FEO2_CORRECTION_IGNORED
//case (DiagnosticErrorOffset + 15):       //VM_DIAG_ERROR_FEO2_CORRECTION_VE_OUT_OF_RANGE
//case (DiagnosticErrorOffset + 16):       //VM_DIAG_ERROR_ADC_TICK_DETECTED



export default itemTypes
